const parseVantivCompletionEvent = (event, expectedOrigin, iframeWindow, processorPaymentId) => {
    // Treat message contents as untrusted until both browser-level boundaries
    // and the versioned payload contract have been verified.
    if (event.origin !== expectedOrigin || event.source !== iframeWindow) {
        return { accepted: false, reason: "untrusted_event" };
    }

    const completion = event.data;
    if (!completion
        || completion.type !== "vantiv-hosted-checkout-complete"
        || completion.version !== 1
        || typeof completion.paymentId !== "string"
        || typeof completion.returnCode !== "number") {
        return { accepted: false, reason: "invalid_event" };
    }

    if (completion.paymentIdMatchesSession === false || completion.paymentId !== processorPaymentId) {
        return { accepted: false, reason: "payment_id_mismatch", completion };
    }

    return { accepted: true, completion };
};

const createVantivVerificationGate = (attemptLimit) => {
    // Kept outside React state so two callbacks in the same render cycle still
    // observe the lock synchronously.
    let attempts = 0;
    let inProgress = false;

    return {
        tryStart() {
            if (inProgress || attempts >= attemptLimit) {
                return false;
            }

            inProgress = true;
            attempts += 1;
            return true;
        },
        finish() {
            inProgress = false;
        },
        getAttempts() {
            return attempts;
        },
        isInProgress() {
            return inProgress;
        },
    };
};

module.exports = { parseVantivCompletionEvent, createVantivVerificationGate };
